import apiClient from '../helpers/apiClient'

const BASE = process.env.REACT_APP_CONFIRMATION_API

// ─── Templates CRUD ───────────────────────────────────────────────────────────

export async function listTemplates (clientId, filters = {}) {
  const params = {}
  if (filters.status) params.status = filters.status
  if (filters.category) params.category = filters.category
  if (filters.language) params.language = filters.language
  if (filters.search) params.search = filters.search
  return apiClient.get(`${BASE}clients/${clientId}/templates`, { params })
}

export async function getTemplate (clientId, id) {
  return apiClient.get(`${BASE}clients/${clientId}/templates/${id}`)
}

export async function createTemplate (clientId, dto) {
  return apiClient.post(`${BASE}clients/${clientId}/templates`, dto)
}

export async function updateTemplate (clientId, id, dto) {
  return apiClient.patch(`${BASE}clients/${clientId}/templates/${id}`, dto)
}

export async function deleteTemplate (clientId, id) {
  return apiClient.delete(`${BASE}clients/${clientId}/templates/${id}`)
}

// ─── Meta actions ─────────────────────────────────────────────────────────────

export async function submitTemplate (clientId, id) {
  return apiClient.post(`${BASE}clients/${clientId}/templates/${id}/submit`)
}

export async function syncTemplates (clientId) {
  return apiClient.post(`${BASE}clients/${clientId}/templates/sync`)
}

// ─── WhatsApp connection ──────────────────────────────────────────────────────

export async function connectWhatsApp (clientId, dto) {
  return apiClient.post(`${BASE}clients/${clientId}/whatsapp/connect`, dto)
}

/** Embedded Signup OAuth flow — exchanges the code server-side for a long-lived token. */
export async function connectWhatsAppOAuth (clientId, dto) {
  return apiClient.post(`${BASE}clients/${clientId}/whatsapp/oauth`, dto)
}

export async function getWhatsAppConnection (clientId) {
  return apiClient.get(`${BASE}clients/${clientId}/whatsapp/connection`)
}

export async function verifyWhatsAppConnection (clientId) {
  return apiClient.post(`${BASE}clients/${clientId}/whatsapp/verify`)
}

export async function disconnectWhatsApp (clientId) {
  return apiClient.delete(`${BASE}clients/${clientId}/whatsapp/disconnect`)
}
